import { Injectable } from '@angular/core';
import { MembershipOption } from './models/membership-option.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface MembershipOptionState extends EntityState<MembershipOption> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'membership-option', idKey: 'MembershipOptionId' })
export class MembershipOptionStore extends EntityStore<MembershipOptionState> {

  constructor() {
    super();
  }

}

